



























import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import VibrationDiagram from '@/components/services/vibrationDiagnostic/VibrationDiagram.vue';
import {DateTimeInterval} from '@/utils/dateTimeItervalUtils';
import {ComparedDiagramData, DiagramData} from '@/interfaces/diagrams';
import {getYAxisName} from '@c/diagrams/utils';
import Loading from '@c/controls/Loading.vue';
import {SignalDiagramData} from '@c/diagrams/interfaces';
import {getApiStore} from '@c/diagrams/utils';

@Component({
  components: {
    VibrationDiagram,
    Loading,
  },
})
export default class VibrationDiagramBox extends Vue {
  data: ComparedDiagramData = {
    mainDiagram: {data: [], yAxis: {name: '', units: ''}, name: '', id: '', visible: true},
    comparedDiagrams: [],
  };

  chartData: DiagramData = {
    data: [],
    yAxis: {name: '', units: ''},
    name: '',
    id: '',
    visible: true,
  };
  comparedChartsData: DiagramData[] = [];

  topLevelChart: any = null;
  bottomLevelChart: any = null;
  topLevel: any = null;
  bottomLevel: any = null;

  @Prop({required: false})
  selectedInterval!: DateTimeInterval;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Показатели загрузки данных и ошибки загрузки данных
  loading = false;
  error = false;

  // Диаграмма
  @Prop({required: true})
  diagram!: SignalDiagramData;

  @Watch('resizedKey')
  onChangedParams() {
    if (
      !this.selectedInterval ||
      !this.selectedInterval.startDateTime ||
      !this.selectedInterval.endDateTime ||
      !this.diagram
    )
      return;
    const endDateTime = this.selectedInterval.endDateTime;
    const startDateTime = this.selectedInterval.startDateTime;
    this.defineInitialChartState(startDateTime, endDateTime);
  }

  // Список диаграмм для сравнения
  @Prop({required: false, default: null})
  comparedDiagrams!: SignalDiagramData[] | null;

  @Watch('comparedDiagrams')
  async onChangeComparedDiagrams() {
    try {
      this.loading = true;
      this.error = false;
      const startDateTime = this.xSoftMin;
      const endDateTime = this.xSoftMax;
      const comparedData = await this.requestComparedChartsConfigData({startDateTime, endDateTime});
      this.defineComparedCharts(comparedData);
      this.setData();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Минимальное значение масштаба по оси X (мс)
  xMinScaleValue = 1000;

  // Показатель сдвига графика при обновлении данных
  isShift = true;

  // Значение soft min и soft max оси x, нужно для того, чтобы при отсутствии данных показывать полный период
  xSoftMin: any = null;
  xSoftMax: any = null;

  // Показатель того, что применен зум, нужно для корректной работы с сокетами
  isInZoom = false;

  mounted() {
    this.$nextTick(() => {
      if (
        !this.selectedInterval ||
        !this.selectedInterval.startDateTime ||
        !this.selectedInterval.endDateTime ||
        !this.diagram
      )
        return;
      const endDateTime = this.selectedInterval.endDateTime;
      const startDateTime = this.selectedInterval.startDateTime;
      this.defineInitialChartState(startDateTime, endDateTime);
    });
  }

  async defineInitialChartState(startDateTime: number, endDateTime: number) {
    this.xSoftMin = startDateTime;
    this.xSoftMax = endDateTime;

    try {
      this.loading = true;
      this.error = false;

      const data = await getApiStore(this.diagram.moduleType).getSignal({
        id: this.diagram.moduleId,
        dateInterval: {startDateTime, endDateTime},
        fieldAlias: this.diagram.measurement.alias,
        statType: this.diagram.measurement.eventType,
      });

      const comparedData = await this.requestComparedChartsConfigData({startDateTime, endDateTime});

      this.defineMainChartAndLevel(data);
      this.defineLevelCharts(this.xSoftMin, this.xSoftMax);
      this.defineComparedCharts(comparedData);
      this.setData();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async returnInitialStateChart() {
    if (this.isInZoom) {
      if (
        !this.selectedInterval ||
        !this.selectedInterval.startDateTime ||
        !this.selectedInterval.endDateTime
      )
        return;
      const endDateTime = this.selectedInterval.endDateTime as number;
      const startDateTime = this.selectedInterval.startDateTime as number;
      this.defineInitialChartState(startDateTime, endDateTime);
      this.isInZoom = false;
    }
  }

  async onChartZoom(dateInterval: DateTimeInterval) {
    this.isInZoom = true;

    const startDateTime = dateInterval.startDateTime as number;
    const endDateTime = dateInterval.endDateTime as number;
    this.xSoftMin = startDateTime;
    this.xSoftMax = endDateTime;

    try {
      this.loading = true;
      this.error = false;

      const data = await getApiStore(this.diagram.moduleType).getSignal({
        id: this.diagram.moduleId,
        dateInterval: {startDateTime, endDateTime},
        fieldAlias: this.diagram.measurement.alias,
        statType: this.diagram.measurement.eventType,
      });

      const comparedData = await this.requestComparedChartsConfigData({startDateTime, endDateTime});

      if (!data.dataSet.length) {
        data.dataSet = [
          {x: dateInterval.startDateTime as number, y: 0},
          {x: dateInterval.endDateTime as number, y: 0},
        ];
      }

      this.defineMainChartAndLevel(data);
      this.defineLevelCharts(this.xSoftMin, this.xSoftMax);
      this.defineComparedCharts(comparedData);
      this.setData();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // сбрасываем флаг зума
  onResetIsInZoom() {
    this.isInZoom = false;
  }

  //Запрос данных связанных графиков (TODO: лучше сделать методом на сервере)
  async requestComparedChartsConfigData(dateInterval: DateTimeInterval) {
    if (!this.comparedDiagrams) return null;
    const comparedChartsData: DiagramData[] = [];
    for (let i = 0; i < this.comparedDiagrams.length; ++i) {
      const diagram = this.comparedDiagrams[i];

      const data = await getApiStore(diagram.moduleType).getSignal({
        id: diagram.moduleId,
        dateInterval,
        fieldAlias: diagram.measurement.alias,
        statType: diagram.measurement.eventType,
      });

      comparedChartsData.push({
        data: data.dataSet,
        yAxis: {
          name: getYAxisName(diagram),
          units: diagram.measurement.unit != '-' ? diagram.measurement.unit : '',
        },
        name: diagram.name ? diagram.name : '',
        id: diagram.id,
        visible: diagram.visible,
      });
    }
    return comparedChartsData;
  }

  //данные для основого графика и пределы
  defineMainChartAndLevel(data: any) {
    this.chartData = {
      data: data.dataSet,
      yAxis: {
        name: getYAxisName(this.diagram),
        units: this.diagram.measurement.unit != '-' ? this.diagram.measurement.unit : '',
      },
      name: this.diagram.name,
      id: this.diagram.id,
      visible: this.diagram.visible,
    };
    this.topLevel = data.topBound ? data.topBound : null;
    this.bottomLevel = data.bottomBound ? data.bottomBound : null;
  }

  //данные для сравниваемых графиков
  defineComparedCharts(data: any[] | null) {
    if (!data) return;
    this.comparedChartsData = data;
  }

  //сами графики уровней
  // TODO вернуть поиск графиков по алиасу
  defineLevelCharts(xMin: number, xMax: number) {
    if (this.topLevel) {
      this.topLevelChart = [
        {x: xMin, y: this.topLevel},
        {x: xMax, y: this.topLevel},
      ];
    }
    if (this.bottomLevel) {
      this.bottomLevelChart = [
        {x: xMin, y: this.bottomLevel},
        {x: xMax, y: this.bottomLevel},
      ];
    }
  }

  setData() {
    this.data = {mainDiagram: this.chartData, comparedDiagrams: this.comparedChartsData};
  }

  onItemLegendClicked(e: any) {
    this.$emit('itemLegendClick', e);
  }
}
